/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.educator-growth.resources'},
});

const ResourcesItem = () => (
  <RouteLinkItem
    route="midas/settings/educator-growth/resources"
    title={messages.title}
  />
);

export default ResourcesItem;
